import React, { useState, useEffect } from 'react'

import styles from './CollectionSEOContents.module.css'
import cx from '../../../utils/className'
import Pressable from '../../common/Pressable/Pressable'

const CollectionSEOContents = props => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (document.getElementById('seo-collection-div')) {
      document.getElementById('seo-collection-div').innerHTML = props.seoContent || ''
    }
  }, [props.seoContent])

  const handleToggleDesc = () => {
    setShow(x => !x)
  }

  const handleCloseDesc = () => {
    window.scrollTo(0,0)
    setShow(false)
  }

  if (props.isDesktop) {
    return (
      <>
        <div className={cx(styles.SEOCollection, styles.isDesktop, show && styles.show)}>
          <div id="seo-collection-div" />
        </div>
        <Pressable className={styles.pcReadMore} onClick={handleToggleDesc} ariaLabel={props.$i18n.transl('core.collection.collectionDescToggle')}>
          <span aria-hidden="true">{props.$i18n.transl(show ? 'core.collection.readLess' : 'core.collection.readMore')}</span>
        </Pressable>
      </>
    )
  }

  return (
    <div className={cx(styles.SEOCollection, show && styles.show)}>
      <Pressable onClick={handleToggleDesc} className={styles.icon} ariaLabel={props.$i18n.transl('core.collection.collectionDescToggle')} />
      <div id="seo-collection-div" />
      {
        show && <Pressable component="span" onClick={handleCloseDesc} className={cx(styles.iconDown)} ariaLabel={props.$i18n.transl('core.collection.collectionDescClose')} />
      }
    </div>
  )
}

export default CollectionSEOContents